<script lang="ts" setup>
import {useFilterStore} from "@/stores/filter";
import {isDesktop} from "@/helpers/breakpointHelpers";

type TProps = {
  title: string
}

const props = defineProps<TProps>()

const filterStore = useFilterStore()

const clickHandler = (e: MouseEvent) => {
  if (isDesktop()) {
    e.preventDefault()
    filterStore.toggleFilter(props.title)
  }
}
</script>

<template>
  <div
    :class="{'bg-[hsl(var(--roke-text-blue))] text-[hsl(var(--roke-white))]': filterStore.isActive(props.title)}"
    class="bg-[hsl(var(--roke-fill-grey))]"
    @click="clickHandler">
    <slot/>
  </div>
</template>
